// ** React Imports
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import {
    Autocomplete,
    Divider,
    Fab,
} from '@mui/material'

import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import { SyntheticEvent, useEffect, useState } from 'react';
import appInfo from '../../../../configs/app-info';
import { getDesigner, getDoctag, getProses,getProsesBorongan, getSite } from '../../../../api/helper';
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import { useToast } from '../../../../components/ToastProvider';

export default function Add() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const navigate = useNavigate();
    const location = useLocation();
    const { id: pathId } = useParams();
    const [searchParams] = useSearchParams();
    const source = searchParams.get('source') || (location.pathname.includes('/add-request/') ? 'request' : location.pathname.includes('/add-so/') ? 'so' : 'manual');
    const id = searchParams.get('id') || pathId;
    const { showToast, hideToast } = useToast();

    const [listSite, setListSite] = useState<any[]>([])
    const [valSite, setValSite] = useState<any>(null)

    const [valDesigner, setValDesigner] = useState<any>(null)
    const [listDesigner, setListDesigner] = useState<any[]>([])
    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])
    const [valProses, setValProses] = useState<any>(null)
    const [listProses, setListProses] = useState<any[]>([])
    const [valJenis, setValJenis] = useState<any>(null)
    const [listJenis, setListJenis] = useState<any[]>([])
    const [listProduct, setListProduct] = useState<any[]>([])
    const [valBarang, setValBarang] = useState<any>(null)
    const [listBarangWo, setListBarangWo] = useState<any[]>([])
    const [openProductDialog, setOpenProductDialog] = useState<boolean>(false)
    interface FormInputs {
        syscabang_id: any,
        sysdoctag_id: any,
        tgl: any,
        tgl_target: any,
        jenis: any,
        qty: any,
        notes: any,
        sdproduct_id: any,
        product: any,
        mmbarang_id: any,
        wo_proses_id: any,
        wo_proses_borongan_id: any,
        kode: any,
        designer_id: any,
        site_id: any
    }

    const now = new Date();
    const defaultDate = new Date(now.getTime() + (7 * 60 * 60 * 1000)).toISOString().slice(0, 16);
    const targetDate = new Date(now.getTime() + (7 * 24 * 60 * 60 * 1000)).toISOString().slice(0, 16);
    const defaultValues = {
        syscabang_id: cabang,
        tgl: defaultDate,
        tgl_target: targetDate
    }

    const rowClickProduct = (e: any) => {
        const data = e.data
        setValue('sdproduct_id', data?.id)
        setValue('product', data?.nama_product)
        setOpenProductDialog(false)
        getListBarangWo();
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    useEffect(() => {
        const fetchDoctag = async () => {
            const response = await getDoctag(appInfo.menuId.workOrder, cabang, token);
            if (response.length > 0 && response.length == 1) {
                setValDoctag(response[0])
                setValue('sysdoctag_id', response[0].id)
            }
            setListDoctag(response);
        };
        const fetchDesigner = async (designerId:any) => {
            const response = await getDesigner(cabang, token);
            if(designerId !=null){
                response.forEach((element: { id: any; }) => {
                    if (element.id === designerId) {
                        setValDesigner(element)
                        setValue('designer_id', element.id)
                    }
                });
            }
            setListDesigner(response);
        };
        const fetchSite = async () => {
            const response = await getSite(cabang, token);
            setListSite(response);
        };
        const getListJenis = () => {
            const url = apiUrl.apiUrl + '/sales/model/list-jenis-model'
            axios
                .get(url, {
                    params: {},
                    headers: { Authorization: `Bearer ${token}` }
                })
                .then(response => {
                    if (response.data.success) {
                        const data = response.data.data
                        setListJenis(data)
                    } else {
                        showToast(response.data.message, 'error');
                    }
                })
        }
        const getReferenceDetail = () => {
            if (source === 'manual') {
                fetchDesigner(null)
                return
            }
            if (!id) {
                showToast('ID referensi work order tidak ditemukan', 'error')
                return
            }
            const detailPath = source === 'request' ? '/production/work-order/detail-request/' : '/production/work-order/detail-so/'
            const url = apiUrl.apiUrl + detailPath + id
            axios
                .get(url, {
                    params: {},
                    headers: { Authorization: `Bearer ${token}` }
                })
                .then(response => {
                    if (response.data.success && source === 'so') {
                        const sdsoD = response.data.sdsod
                        const sdso = response.data.sdso

                        setValue('jenis', response.data.jenis.nama)
                        setValJenis(response.data.jenis)

                        setValue('sdproduct_id', sdsoD.sdproduct_id)
                        setValue('product', sdsoD.nama)
                        setValue('qty', sdsoD.qty)
                        setValue('kode',sdso.kode)
                        setValue('designer_id',sdso.designer_id)
                        setValue('site_id',1)
                        setValSite({id:1,nama:'Rangkah'})
                        fetchProsesById(1)

                        fetchDesigner(sdso.designer_id)
                        const tglValue = new Date(sdso.tgl_kirim);
                        tglValue.setDate(tglValue.getDate() - 2);
                        setValue('tgl_target', sdso.tgl_kirim)
                        setValue('tgl', tglValue.toISOString().slice(0, 16));

                        getListBarangWo();
                    } else if (response.data.success && source === 'request') {
                        const data = response.data.data
                        const product = response.data.product

                        setValue('jenis', response.data.jenis.nama)
                        setValJenis(response.data.jenis)
                        setValue('sdproduct_id', product.id)
                        setValue('product', product.nama_product)
                        setValue('qty', data.qty_request)
                        setValue('mmbarang_id', data.mmbarang_id)
                        setValue('notes', data.keterangan)
                        setValue('site_id', 1)
                        setValSite({ id: 1, nama: 'Rangkah' })
                        fetchProsesById(1)

                        fetchDesigner(null)
                        const requestDate = new Date(data.tgl)
                        requestDate.setDate(requestDate.getDate() - 2)
                        setValue('tgl_target', requestDate.toISOString().slice(0, 16))
                        setValue('tgl', requestDate.toISOString().slice(0, 16))
                        getListBarangWo();
                    } else {
                        showToast(response.data.message, 'error');
                    }
                })
        }
        getReferenceDetail();
        getListJenis();
        fetchDoctag();
        fetchSite();
    }, [])

    const fetchProsesById = async (siteId: any) => {
        const isBorongan = Number(siteId) === 2;
        const response = isBorongan
            ? await getProsesBorongan(token)
            : await getProses(token);

        setValProses(null)
        setValue('wo_proses_id', null)
        setValue('wo_proses_borongan_id', null)

        if (response.length > 0 && response.length == 1) {
            setValProses(response[0])
            if (isBorongan) {
                setValue('wo_proses_borongan_id', response[0].id)
            } else {
                setValue('wo_proses_id', response[0].id)
            }
        }
        setListProses(response);
    };

    const getListBarangWo = () => {
        const url = apiUrl.apiUrl + '/mm/barang/list-barang-wo/' + getValues('sdproduct_id')
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    if (source === 'request') {
                        const selectedBarang = data.find((item: any) => item.id == getValues('mmbarang_id'))
                        if (selectedBarang) setValBarang(selectedBarang)
                    }
                    setListBarangWo(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const customRender = [
        {
            key: "link",
            renderCell: (row: any) =>
                row.link ? (
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                            e.stopPropagation(); // cegah rowClick
                            setOpenProductDialog(false);
                            Swal.fire({
                                title: 'Preview Gambar',
                                html: `<img src="${row.link}" alt="Gambar" style="max-width:100%;max-height:400px;" />`,
                                showCloseButton: true,
                                showConfirmButton: true,
                                confirmButtonText: 'OK',
                                width: 600,
                            }).then(result => {
                                if (result.isConfirmed) {
                                    setOpenProductDialog(true);
                                }
                            });
                        }}
                    >
                        <Icon icon="mdi:search" fontSize={20} />
                        View Image
                    </Button>
                ) : (
                    <Icon icon="mdi:close-circle-outline" fontSize={24} color="grey" />
                ),
        }
    ];

    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sysdoctag_id', newValue ? newValue.id : null)
        setValDoctag(newValue)
    }
    const handleChangeAutocompleteSite = (event: SyntheticEvent, newValue: any | null) => {
        setValue('site_id', newValue ? newValue.id : null)
        setValSite(newValue)
        setValProses(null)
        setListProses([])
        setValue('wo_proses_id', null)
        setValue('wo_proses_borongan_id', null)
        if (newValue != null) {
            fetchProsesById(newValue.id);
        }
    }

    const onSubmit = (data: any) => {
        if (Number(data.site_id) === 2) {
            data.wo_proses_id = null;
        } else {
            data.wo_proses_borongan_id = null;
        }
        if (source === 'so') data.sdso_d_id = id;
        if (source === 'request') {
            data.wo_req_id = id;
            data.sdso_d_id = null;
        }
        const url = apiUrl.apiUrl + '/production/work-order/add'
        axios
            .post(url, data, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, 'success');
                    navigate('/production/work-order/detail/' + response.data.data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    }

    const handleChangeAutocompleteJenis = (event: SyntheticEvent, newValue: any | null) => {
        setValue('jenis', newValue ? newValue.nama : null)
        setValJenis(newValue)
    }

    const handleChangeAutocompleteBarang = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmbarang_id', newValue ? newValue.id : null)
        setValBarang(newValue)
    }

    const handleChangeAutocompleteProses = (event: SyntheticEvent, newValue: any | null) => {
        if (Number(getValues('site_id')) === 2) {
            setValue('wo_proses_borongan_id', newValue ? newValue.id : null)
            setValue('wo_proses_id', null)
        } else {
            setValue('wo_proses_id', newValue ? newValue.id : null)
            setValue('wo_proses_borongan_id', null)
        }
        setValProses(newValue)
    }
    const handleChangeAutocompleteDesigner = (event: SyntheticEvent, newValue: any | null) => {
        setValue('designer_id', newValue ? newValue.id : null)
        setValDesigner(newValue)
    }

    const getProduct = (jenisProduct: any) => {
        if (jenisProduct == '') {
            showToast('Silahkan pilih jenis product terlebih dahulu', 'warning');
            return;
        }

        const url = apiUrl.apiUrl + '/sales/product/list-combo?mode=full&jenis_product=' + jenisProduct
        axios.get(url, {
            params: {},
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListProduct(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Buat Work Order
                    </Typography>
                    <Divider sx={{ m: 0 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3} sx={{ mt: 1 }}>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valDoctag}
                                        options={listDoctag}
                                        id='doctag'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteDoctag}
                                        getOptionLabel={(option: any) => option?.nama || ""}   // 👈 penting
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Document'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='jenis'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valJenis}
                                                options={listJenis}
                                                id='jenis'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                getOptionLabel={(option: any) => option?.nama || ""}   // 👈 penting
                                                onChange={handleChangeAutocompleteJenis}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        required
                                                        label='Jenis Product'
                                                        error={Boolean(errors.jenis)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.jenis && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={5} sm={5}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='product'
                                        control={control}
                                        render={({ field: { value } }) => (
                                            <TextField
                                                label='Product'
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={1} sm={1} sx={{ display: 'flex', alignItems: 'center' }}>
                                <Fab color='info' size='medium' onClick={() => {
                                    if (valJenis == null) {
                                        showToast('Silahkan pilih jenis product terlebih dahulu', 'warning');
                                        return;
                                    }
                                    getProduct(valJenis ? valJenis.nama : '');
                                    setOpenProductDialog(true);
                                }}
                                >
                                    <Icon icon='mdi:search' fontSize={35} color='white' />
                                </Fab>
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='mmbarang_id'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valBarang}
                                                options={listBarangWo}
                                                id='barang'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                getOptionLabel={(option: any) => option?.nama || ""}   // 👈 penting
                                                onChange={handleChangeAutocompleteBarang}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        required
                                                        label='Barang'
                                                        error={Boolean(errors.mmbarang_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.mmbarang_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={1} sm={1}>
                                <Fab color='primary' size='medium' onClick={() => {
                                    if (getValues('sdproduct_id') == null) {
                                        showToast('Silahkan pilih product terlebih dahulu', 'warning');
                                        return;
                                    }
                                    Swal.fire({
                                        title: 'Tambah Barang',
                                        input: 'text',
                                        inputLabel: 'Nama Barang',
                                        inputPlaceholder: 'Masukkan nama barang',
                                        showCancelButton: true,
                                        confirmButtonText: 'Simpan',
                                        cancelButtonText: 'Batal',
                                        inputValidator: (value) => {
                                            if (!value) {
                                                return 'Form ini tidak boleh kosong.'
                                            }
                                        }
                                    }).then(result => {
                                        if (result.isConfirmed && result.value) {
                                            const barang = result.value;
                                            const data = { barang };
                                            const url = apiUrl.apiUrl + '/mm/barang/add-barang-work-order/' + getValues('sdproduct_id');
                                            axios
                                                .post(url, data, {
                                                    headers: { Authorization: `Bearer ${token}` }
                                                })
                                                .then(response => {
                                                    if (response.data.success) {
                                                        showToast(response.data.message, 'success');
                                                        getListBarangWo();
                                                    } else {
                                                        showToast(response.data.message, 'error');
                                                    }
                                                })
                                                .catch(error => {
                                                    showToast(error.message, 'error');
                                                });
                                        }
                                    });
                                }}
                                >
                                    <Icon icon='mdi:plus' fontSize={35} color='white' />
                                </Fab>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl_target'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='datetime-local'
                                                value={value}
                                                label='Target Kirim'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ readOnly: true }}
                                                error={Boolean(errors.tgl_target)}
                                            />
                                        )}
                                    />
                                    {errors.tgl_target && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Tanggal harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='datetime-local'
                                                value={value}
                                                label='Tanggal Deadline'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.tgl)}
                                            />
                                        )}
                                    />
                                    {errors.tgl && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Tanggal harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='kode'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Kode WO*'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                error={Boolean(errors.kode)}
                                            />
                                        )}
                                    />
                                    {errors.kode && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Kode harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='qty'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Qty'
                                                type='number'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                error={Boolean(errors.qty)}
                                            />
                                        )}
                                    />
                                    {errors.qty && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Qty harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valSite}
                                        options={listSite}
                                        id='site'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteSite}
                                        getOptionLabel={(option: any) => option?.nama || ""}   // 👈 penting
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Site'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valDesigner}
                                        options={listDesigner}
                                        id='designer_id'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteDesigner}
                                        getOptionLabel={(option: any) => option?.nama || ""}   // 👈 penting
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Designer'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valProses}
                                        options={listProses}
                                        id='proses'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteProses}
                                        getOptionLabel={(option: any) => option?.nama || ""}   // 👈 penting
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Proses'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='notes'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                onChange={onChange}
                                                multiline
                                                rows={4}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>
            <Dialog
                maxWidth={'xl'}
                fullWidth={true}
                open={openProductDialog}
                onClose={() => setOpenProductDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        List Product {valJenis ? valJenis.nama : ''}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 4 }}>
                    <Grid container spacing={4}>
                        <MsiDatagrid array={listProduct} rowClick={rowClickProduct} customRender={customRender} />
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenProductDialog(false)}>Batal</Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}
